import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { closed } from "../../components/drawer/drawerSlice";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createRelation,
  getAllRelation,
  getRelationById,
  updateRelation,
} from "./services/relation.services";
import { clearRelationDetails } from "./relationSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";

const CreateRelation: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const RelationDetail = useAppSelector(
    (state) => state.relation.RelationDetail
  );
  const RelationGUID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.relation.formLoading);

  useEffect(() => {
    return () => {
      dispatch(clearRelationDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (RelationGUID) {
      dispatch(getRelationById(RelationGUID));
    }
  }, [RelationGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!RelationGUID) {
        const insertPayload = {
          RelationName: values?.RelationName ? values?.RelationName : "",
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(createRelation(insertPayload));
        if (response?.payload?.Status === 201) {
          dispatch(closed());
          dispatch(clearRelationDetails());
          dispatch(getAllRelation());
        }
      } else {
        const editPayload = {
          RelationGUID: RelationGUID,
          RelationName: values?.RelationName ? values?.RelationName : "",
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(updateRelation(editPayload));
        if (response?.payload?.Status === 200) {
          dispatch(closed());
          dispatch(clearRelationDetails());
          dispatch(getAllRelation());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={RelationDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem className="drawer-header">
              <Typography.h4 className="m-0">
                {RelationGUID ? "Update Relation" : "Create Relation"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="RelationName"
                label="Relation Name"
                placeholder="Relation Name"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"IsActive"}
                label={"Status"}
                placeholder="Status"
                component={FormSelectionField}
                validator={requiredValidator} astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              style={{
                marginTop: 20,
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={RelationGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateRelation;
